import TermsConditionsList from "../terms-and-conditions/TermsConditionsList";

export default function CompanyTermsConditionsList() {
  return (
    <TermsConditionsList
      tcType="company"
      listPath="/company-terms-and-conditions"
      addPath="/add/company-terms-and-conditions"
      editPath="/edit/company-terms-and-conditions"
    />
  );
}
